import React, { useMemo } from 'react';

import { Flex, Tag, Label } from '@sopranodesign/pulse-components';
import { useAuth } from '@sopranodesign/pulse-auth';

const ActiveStatus = () => (
  <Flex fat>
    <Flex fat="true" growChildren>
      <Tag background_colour="positive" colour="positive">
        <Flex middle>
          <Label colour="positive" mb={false}>
            Active License
          </Label>
        </Flex>
      </Tag>
    </Flex>
  </Flex>
);

const ExpiringStatus = () => (
  <Flex fat>
    <Flex fat="true" growChildren>
      <Tag background_colour="warning" colour="warning">
        <Flex middle>
          <Label mb={false}>License Expiring</Label>
        </Flex>
      </Tag>
    </Flex>
  </Flex>
);

const ExpiredStatus = () => (
  <Flex fat>
    <Flex fat="true" growChildren>
      <Tag background_colour="danger" colour="danger">
        <Flex middle>
          <Label mb={false}>Expired License</Label>
        </Flex>
      </Tag>
    </Flex>
  </Flex>
);

const NoLicense = () => (
  <Flex fat>
    <Flex fat="true" growChildren>
      <Tag background_colour="danger" colour="danger">
        <Flex middle>
          <Label mb={false}>No License</Label>
        </Flex>
      </Tag>
    </Flex>
  </Flex>
);

const statuses = {
  active: ActiveStatus,
  expiring: ExpiringStatus,
  expired: ExpiredStatus
};

const LicenseStatus = () => {
  const { client } = useAuth();

  const Component = useMemo(() => {
    const license = client.license;

    if (!license) {
      return NoLicense;
    }

    return statuses[license.status];
  }, [client]);

  return <Component />;
};

export default LicenseStatus;
